module.exports = __webpack_public_path__ + "media/images/background_efficacy-ada498efaf8136d48c6faf2b79eec606.jpg";